import { useState } from "react";
import Layout from "@/components/Layout";
import { useAuth } from "@/context/AuthContext";
import { api, formatApiError } from "@/lib/api";
import { toast } from "sonner";

const inputCls =
  "w-full h-11 rounded-lg border border-slate-200 bg-white px-4 text-sm focus:outline-none focus:ring-1 focus:ring-slate-400 focus:border-slate-400 placeholder:text-slate-400 transition-colors";

export default function Settings() {
  const { user } = useAuth();
  const [cur, setCur] = useState("");
  const [next, setNext] = useState("");
  const [conf, setConf] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    if (next.length < 8) return setError("Yeni şifre en az 8 karakter olmalıdır.");
    if (next !== conf) return setError("Yeni şifreler eşleşmiyor.");
    setLoading(true);
    try {
      await api.post("/auth/change-password", { current_password: cur, new_password: next });
      toast.success("Şifre güncellendi");
      setCur(""); setNext(""); setConf("");
    } catch (err) {
      setError(formatApiError(err.response?.data?.detail));
    } finally {
      setLoading(false);
    }
  };

  return (
    <Layout>
      <div className="mb-10 border-b border-slate-100 pb-6" data-testid="settings-header">
        <h1 className="text-4xl tracking-tight font-bold text-slate-900">Ayarlar</h1>
        <p className="text-sm text-slate-500 mt-2">Hesap bilgileriniz ve güvenlik.</p>
      </div>

      <div className="grid grid-cols-2 gap-8">
        <div className="rounded-xl border border-slate-200 bg-white p-8" data-testid="account-card">
          <h2 className="text-lg tracking-tight font-semibold text-slate-900 mb-6">Hesap</h2>
          <div className="space-y-4">
            <div>
              <div className="text-xs font-semibold tracking-wider uppercase text-slate-400 mb-1.5">İsim</div>
              <div className="text-sm text-slate-900" data-testid="account-name">{user?.name}</div>
            </div>
            <div>
              <div className="text-xs font-semibold tracking-wider uppercase text-slate-400 mb-1.5">E-posta</div>
              <div className="text-sm text-slate-900" data-testid="account-email">{user?.email}</div>
            </div>
            <div>
              <div className="text-xs font-semibold tracking-wider uppercase text-slate-400 mb-1.5">Rol</div>
              <div className="text-sm text-slate-900" data-testid="account-role">Satış Yetkilisi</div>
            </div>
          </div>
        </div>

        <form onSubmit={submit} className="rounded-xl border border-slate-200 bg-white p-8" data-testid="password-card">
          <h2 className="text-lg tracking-tight font-semibold text-slate-900 mb-6">Şifre Değiştir</h2>
          <div className="space-y-4">
            <div>
              <label className="block text-xs font-semibold tracking-wider uppercase text-slate-400 mb-2">Mevcut Şifre</label>
              <input type="password" required value={cur} onChange={(e) => setCur(e.target.value)} className={inputCls} data-testid="pw-current" />
            </div>
            <div>
              <label className="block text-xs font-semibold tracking-wider uppercase text-slate-400 mb-2">Yeni Şifre</label>
              <input type="password" required value={next} onChange={(e) => setNext(e.target.value)} className={inputCls} data-testid="pw-new" />
            </div>
            <div>
              <label className="block text-xs font-semibold tracking-wider uppercase text-slate-400 mb-2">Yeni Şifre (Tekrar)</label>
              <input type="password" required value={conf} onChange={(e) => setConf(e.target.value)} className={inputCls} data-testid="pw-confirm" />
            </div>
            {error && <div data-testid="pw-error" className="text-sm text-red-600 bg-red-50 border border-red-100 rounded-lg px-4 py-3">{error}</div>}
          </div>
          <div className="mt-6 flex justify-end">
            <button
              type="submit"
              disabled={loading}
              data-testid="pw-submit"
              className="rounded-full bg-slate-900 text-white hover:bg-slate-800 px-6 py-2.5 font-medium text-sm transition-colors duration-150 disabled:opacity-50"
            >
              {loading ? "Güncelleniyor..." : "Şifreyi Güncelle"}
            </button>
          </div>
        </form>
      </div>
    </Layout>
  );
}
